import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sort-order"
export default class extends Controller {
  static targets = ["input"]

  change() {
    const newSortOrder = this.inputTarget.value
    const url = this.inputTarget.dataset.url
    const collectionItemId = this.inputTarget.dataset.collectionItemId

    fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        sort_order: newSortOrder,
        collection_item_id: collectionItemId
      })
    })
    .then(response => response.text())
    .then(html => Turbo.renderStreamMessage(html))
    .catch(error => console.error('Error updating sort order:', error))
  }
}
